/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { notificationService } from '../../../api/services/notificationService';
import { setheaderNotifData } from '../../../infra/aggregates/NotificationSlice';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';

interface PropsValues {
  setheaderNotif: (data: any) => void;
}
function DTOHeaderNotification({ setheaderNotif }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);
  const userId = selector.authSlice.user_id;
  const companyId = selector.authSlice.company_id;
  const emp_id = selector.authSlice.emp_id;

  const HeaderNotifList = useAppSelector(
    (state) => state.NotificationSlice.headerNotifData,
  );

  async function getHeaderNotification(
    userId: number,
    companyId: number,
    emp_id: number,
  ) {
    const response = await notificationService.getHeaderNotifications(
      userId,
      companyId,
      emp_id,
    );
    if (response.response == 'success') {
      const headerNotifData: any = response?.data;
      dispatch(setheaderNotifData(headerNotifData));
      setheaderNotif(response?.data);
    }
  }
  useEffect(() => {
    getHeaderNotification(userId, companyId, emp_id);
  }, []);
  useEffect(() => {
    setheaderNotif(HeaderNotifList);
  }, [HeaderNotifList]);
  return <></>;
}
export default DTOHeaderNotification;
